import React from 'react';
import { connect } from 'react-redux';

import { Select } from 'redpoints-front-components/index';
import { withQueryParams } from 'redpoints-front-common/components';

import {
  shortenerResolutionClear,
  shortenerResolutionSetFiltersSelected,
} from '../../../actions/shortenerResolutionActions';
import {
  getShortenerResolutionDomains,
  getShortenerResolutionFiltersSelected,
} from '../../../reducers/tasks/shortenerResolution';
import { translate } from '../../../helpers/languageHelper';
import { getDomainByUrl } from './shortenerResolutionFiltersHelpers';

const ShortenerResolutionFilterDomains = ({
  domains,
  filtersSelected,
  shortenerResolutionSetFiltersSelected,
}) => {
  const { domain: selectedDomain } = filtersSelected;

  const handleDomainChange = value => {
    shortenerResolutionSetFiltersSelected({
      ...filtersSelected,
      domain: getDomainByUrl({ domains, url: value }),
    });
  };

  return (
    <Select
      aria-label="shortener-resolution-domain-filter-select"
      data={domains}
      label={translate('tasks.shortenerResolution.domain.label')}
      mapping={{ key: 'url', value: 'description' }}
      onChange={handleDomainChange}
      showSearch
      value={selectedDomain?.url}
    />
  );
};

const mapStateToProps = state => ({
  domains: getShortenerResolutionDomains(state),
  filtersSelected: getShortenerResolutionFiltersSelected(state),
});

export default withQueryParams(
  connect(mapStateToProps, {
    shortenerResolutionClear,
    shortenerResolutionSetFiltersSelected,
  })(ShortenerResolutionFilterDomains)
);
